<template>
  <el-dialog append-to-body width="440px" :visible.sync="dialogVisible">
    <div class="record-box">
      <img src="../../assets/imgs/detail/record.png" alt="" class="record-img">
      <div class="record-text">
        您的作品未开启源头认证
      </div>
      <div class="record-text">
        暂不支持发售
      </div>
      <div class="btn-box">
        <div class="record-btn record-btn-right" @click="applyAgain">
          <span class="record-btn-color">补充源头认证资料</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    hide () {
      this.dialogVisible = false
    },
    applyAgain () {
      this.hide()
      this.$emit('applyAgain')
    }
  }
}
</script>

<style lang="scss" scoped>
  .record-box{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    box-sizing: border-box;
    padding: 20px;
  }
  .record-img{
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  .record-text{
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #fff;
  }
  .btn-box{
    display: flex;
    justify-content: center;
  }
  .record-btn{
    width: 240px;
    height: 40px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
  }
  .record-btn-left{
    margin-right: 20px;
    background-image: linear-gradient(to right,$linear-color1,$linear-color2);
  }
  .record-btn-right{
    background-image: linear-gradient(to right,$linear-sub-btn1,$linear-sub-btn2);
  }
  .record-btn-color{
    font-size: 14px;
    color: $btn-font-color;
    cursor: pointer;
  }
  .record-gold{
    color: #fff;
  }
</style>